const actions = {
    FETCH_EVENT_TYPES: 'FETCH_EVENT_TYPES',
    FETCH_EVENT_TYPES_SUCCESS: 'FETCH_EVENT_TYPES_SUCCESS',
    FETCH_EVENT_TYPES_ERROR: 'FETCH_EVENT_TYPES_ERROR',

    fetchEventTypes: (search) => ({
        type: actions.FETCH_EVENT_TYPES,
        search,
    }),

    fetchEventsSuccess: (events) => ({
        type: actions.FETCH_EVENT_TYPES_SUCCESS,
        events,
    })
}

export default actions;